/** Shown by filter drawer search fields when a search matches nothing. */
export const DATATABLE_FILTER_NO_RESULTS_TEXT = 'No results found';
